import { Link } from "react-router-dom"
import LOGO from "../../assets/log2.svg"
import facebook from "../../assets/facebook.svg"
import instagram from "../../assets/instagram.svg"
import linkedin from "../../assets/linkedin.svg"

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <div className="bg-dark pt-20">
      <div className="px-[5%] flex flex-col md:flex-row justify-between items-start">
        <div className="md:w-1/2 w-full">
          <div className="w-fit relative flex flex-col">
            <Link to="/" className="w-fit">
              <img src={LOGO || "/placeholder.svg"} alt="Simdozi Logo" className="w-24 h-auto" />
            </Link>
            <p className="text-white font-medium text-[14px] md:text-[19px] ease duration-800 transition-all ">
            Health, Productivity & Economic empowerment{" "}
            </p>
          </div>
          <div className="mt-14">
            <p className="text-secondary font-extrabold text-[14px] md:text-[19px] ease duration-800 transition-all ">
              QUICK LINKS
            </p>
            <div className="flex md:flex-row flex-col gap-7 mt-10">
              <Link
                to="/about"
                className="text-white font-medium text-[14px] md:text-[19px] ease duration-800 transition-all "
              >
                About Us
              </Link>
              <Link
                to="/services/training"
                className="text-white font-medium text-[14px] md:text-[19px] ease duration-800 transition-all "
              >
                Training & Mentorship
              </Link>{" "}
              <Link
                to="/services/chyson-foods"
                className="text-white font-medium text-[14px] md:text-[19px] ease duration-800 transition-all "
              >
                Chyson Foods
              </Link>{" "}
              <Link
                to="/services/gallery"
                className="text-white font-medium text-[14px] md:text-[19px] ease duration-800 transition-all "
              >
                Gallery
              </Link>{" "}
              <Link
                to="/services/farming#consultantcy"
                className="text-white font-medium text-[14px] md:text-[19px] ease duration-800 transition-all "
              >
                Ohaji Farm
              </Link>{" "}
              
              <Link
                to="/contact"
                className="text-white font-medium text-[14px] md:text-[19px] ease duration-800 transition-all "
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
        <div className="md:w-1/2 w-full md:mt-0 mt-20">
          <div className="flex flex-col items-start md:items-end">
            <p className="text-secondary font-extrabold text-[14px] md:text-[19px] ease duration-800 transition-all ">
              EMAIL ADDRESS
            </p>
            <a
              href="mailto:simdozi.internationaltd@gmail.com"
              className="text-white font-medium text-[14px] md:text-[19px] ease duration-800 transition-all "
            >
              simdozi.internationaltd@gmail.com
            </a>
            <a
              href="mailto:info@simdoziinternationaltd.com"
              className="text-white font-medium text-[14px] md:text-[19px] ease duration-800 transition-all "
            >
              info@simdoziinternationaltd.com
            </a>
          </div>

          <div className="flex flex-col items-start md:items-end mt-12">
            <p className="text-secondary font-extrabold text-[14px] md:text-[19px] ease duration-800 transition-all uppercase">
              Phone Numbers
            </p>
            <a
              href="tel:+234(704)4449882"
              className="text-white font-medium text-[14px] md:text-[19px] ease duration-800 transition-all "
            >
              +234 (809) 1399 850 <br />
              +234 (803) 5564 010
            </a>
          </div>
          <div className="flex flex-col items-start md:items-end mt-12">
            <p className="text-secondary font-extrabold text-[14px] md:text-[19px] ease duration-800 transition-all uppercase">
             Registered Office Address
            </p>
            <a
              href="tel:+234(704)4449882"
              className="text-white font-medium text-[14px] md:text-[19px] ease duration-800 transition-all "
            >
             No. 1 Abdou Diof Street, Asokoro, Abuja
            </a>
          </div>
        </div>
      </div>
      <div className="bg-white w-full h-[1px] my-10"></div>
      <div className="px-[5%] flex flex-col-reverse md:flex-row justify-between items-start pb-5 md:gap-0 gap-4">
        <p className="text-[#EEF5FF]">Copyright ©{currentYear} Simdozi International Limited</p>
        <div className="flex gap-3">
          <div className="flex items-center gap-4">
  <a
    href="https://web.facebook.com/simdozi.international?_rdc=1&_rdr"
    target="_blank"
    rel="noopener noreferrer"
    className="transition-transform duration-300 hover:scale-110"
  >
    <img src={facebook} alt="Facebook" className="w-6 h-6" />
  </a>

  <a
    href="https://www.instagram.com/simdozi.international?igsh=MWU4ZWpoZTU4cXc5cw=="
    target="_blank"
    rel="noopener noreferrer"
    className="transition-transform duration-300 hover:scale-110"
  >
    <img src={instagram} alt="Instagram" className="w-6 h-6" />
  </a>

  <a
    href="https://www.linkedin.com/in/esonu-udeala-a4b32a20b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    target="_blank"
    rel="noopener noreferrer"
    className="transition-transform duration-300 hover:scale-110"
  >
    <img src={linkedin} alt="LinkedIn" className="w-6 h-6" />
  </a>
</div>

        </div>
      </div>
    </div>
  )
}

export default Footer
